<script lang="ts">
  import Icon from '@iconify/svelte'
  import type { Props } from './service.types'

  const { icon, title, description, href }: Props = $props()
</script>

<div
  class="service | group/service relative w-full cursor-default overflow-hidden rounded-xl border border-gray-200 transition"
>
  <div class="service__content | relative z-10 size-full min-h-[180px] p-5 backdrop-blur-md">
    {#if icon}
      <div class="service__figure | text-brand/50 group-hover/service:text-brand">
        <Icon class="size-[56px]" {icon} />
      </div>
    {/if}

    <h3 class="service__title | mb-2 min-h-[64px] text-lg font-medium sm:text-xl">
      <span class="text-brand-600 group-hover/service:text-brand">{title}</span>
    </h3>

    <div
      class="service__description | min-h-[132px] text-sm font-medium text-gray-600 transition group-hover/service:text-gray-900"
    >
      <p>
        {description}
      </p>
    </div>

    {#if href}
      <a
        class="flex w-auto justify-start rounded-lg text-brand-500 underline"
        target="_blank"
        {href}
      >
        Saiba mais...
      </a>
    {/if}
  </div>

  {#if href}
    <a {href} class="absolute left-0 top-0 z-10 h-full w-full" target="_blank">
      <span class="sr-only">{title}</span>
    </a>
  {/if}
</div>
